import React from 'react'
import {
  AppFooterContainer,
  AppFooterLayoutContainer,
  AppPageContentContainer,
} from './AppFooter.styles'

function AppFooter() {
  const year = new Date().getFullYear()
  return (
    <AppFooterContainer data-test="app-footer">
      Copyright @ {year} Thryv, Inc.
    </AppFooterContainer>
  )
}

function AppFooterLayout({children}) {
  return (
    <AppFooterLayoutContainer>
      {children}
      <AppFooter />
    </AppFooterLayoutContainer>
  )
}

// `edgeToEdge`: drop the side padding (e.g. Keap Partner landing page).
// `topGap`: CSS length of space between the header and the content.
function AppPageContent({children, edgeToEdge = false, topGap}) {
  return (
    <AppPageContentContainer edgeToEdge={edgeToEdge} topGap={topGap}>
      {children}
    </AppPageContentContainer>
  )
}

export {AppFooter, AppFooterLayout, AppPageContent}
